module.exports = "<div class=modal-body> <share-menu post-id=postId></share-menu> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/share/share-menu-modal.html
// module id = 780
// module chunks = 0